import { assignJob, getFreePopulation, MAX_FORESTERS } from '../map/settlement';
import type { ModalActionHandler } from './modalActionTypes';
import { getSettlement } from './settlementActionUtils';

export const hireForesterAction: ModalActionHandler = (state, modal) => {
    const settlement = getSettlement(state, modal);
    if (!settlement || settlement.buildings.lumberjack.qty <= 0) return false;
    const freePop = getFreePopulation(settlement);
    const cap = MAX_FORESTERS * settlement.buildings.lumberjack.qty;
    if (settlement.jobs.foresters >= cap || freePop <= 0) return false;
    if (!assignJob(settlement, 'foresters')) return false;
    return true;
};
